import { Breadcrumb, Menu } from 'antd';
import { Link, useParams } from 'react-router';

import { useGetSchoolDataQuery } from '@/api/endpoints/schools';
import { FetchDataWrapper } from '@/shared/components';
import { ROUTES } from '@/shared/consts';
import { usePageTitle } from '@/shared/hooks';

import { ESelectionPanelTabs } from './consts';
import styles from './SelectionPanelHeader.module.scss';

interface IProp {
  currentTab: ESelectionPanelTabs;
}

export const SelectionPanelHeader = ({ currentTab }: IProp) => {
  const { id: schoolId } = useParams();

  const {
    data: schoolData,
    isLoading: isSchoolDataLoading,
    isError: isSchoolDataFetchError,
  } = useGetSchoolDataQuery({ id: Number(schoolId) });

  usePageTitle(`Школы - Панель отбора школы`);

  const menuItems = [
    {
      label: (
        <Link
          to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}/${ROUTES.SELECTION_PANEL}/${ROUTES.ADMISSION_SURVEY}/${ROUTES.VIEW}`}
        >
          Опрос
        </Link>
      ),
      key: ESelectionPanelTabs.AdmissionSurvey,
    },
    {
      label: (
        <Link
          to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}/${ROUTES.SELECTION_PANEL}/${ROUTES.APPLICATIONS}`}
        >
          Этап 1: Заявки
        </Link>
      ),
      key: ESelectionPanelTabs.Applications,
    },
    {
      label: (
        <Link to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}/${ROUTES.SELECTION_PANEL}/${ROUTES.TESTING}`}>
          Этап 2: Тестирование
        </Link>
      ),
      key: ESelectionPanelTabs.Testing,
    },
    {
      label: (
        <Link to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}/${ROUTES.SELECTION_PANEL}/${ROUTES.ENROLLED}`}>
          Зачисленные
        </Link>
      ),
      key: ESelectionPanelTabs.Enrolled,
    },
    {
      label: (
        <Link to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}/${ROUTES.SELECTION_PANEL}/${ROUTES.USERS}`}>
          Все пользователи
        </Link>
      ),
      key: ESelectionPanelTabs.Users,
    },
  ];

  return (
    <FetchDataWrapper
      isLoading={isSchoolDataLoading}
      isError={isSchoolDataFetchError}
    >
      <div className={styles.wrapper}>
        <Breadcrumb
          items={[
            { title: 'Публичные страницы' },
            { title: <Link to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}`}>Школы</Link> },
            { title: <Link to={`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}`}>{schoolData?.name}</Link> },
            { title: 'Панель отбора' },
          ]}
        />
        <Menu
          className={styles.menu}
          items={menuItems}
          selectedKeys={[currentTab]}
          mode="horizontal"
        />
      </div>
    </FetchDataWrapper>
  );
};
